import { useEffect } from 'react';
import { transformValidationErrors } from '../validation/validationHelpers';

type TFormikErrorHandler = (params: {
  errors: any;
  setFieldError: any;
}) => void;

export const useFormikErrorsHandler: TFormikErrorHandler = (params) => {
  const { errors, setFieldError } = params;
  useEffect(() => {
    const transformedError = transformValidationErrors(
      errors?.response?.data.errors || errors,
    );
    if (transformedError) {
      // @ts-ignore
      if (Object.keys(transformedError).length) {
        // @ts-ignore
        // eslint-disable-next-line array-callback-return
        Object.entries(transformedError).forEach(([key, value]) => {
          setFieldError(key, value);
        });
      }
    }
  }, [errors, setFieldError]);
};
